
import { useState, useEffect } from "react"
import { Button } from "@/components/ui/button"

export function FixPointerEventsButton() {
  const [isVisible, setIsVisible] = useState(false)
  const [isPointerEventsNone, setIsPointerEventsNone] = useState(false)

  useEffect(() => {
    // Check if pointer-events is none on mount
    const bodyStyle = window.getComputedStyle(document.body)
    setIsPointerEventsNone(bodyStyle.pointerEvents === "none")

    // Show button after a short delay in development
    const timer = setTimeout(() => {
      setIsVisible(true)
    }, 2000)

    // Check for pointer-events changes
    const interval = setInterval(() => {
      const currentStyle = window.getComputedStyle(document.body)
      setIsPointerEventsNone(currentStyle.pointerEvents === "none")
    }, 500)

    return () => {
      clearTimeout(timer)
      clearInterval(interval)
    }
  }, [])

  const fixPointerEvents = () => {
    console.log("Manually fixing pointer events")
    document.body.style.pointerEvents = "auto"
    document.documentElement.style.pointerEvents = "auto"

    // Apply inline styles to override any CSS classes
    const style = document.createElement("style")
    style.textContent = "body, html { pointer-events: auto !important; }"
    document.head.appendChild(style)

    // Remove the style after a short delay
    setTimeout(() => {
      if (document.head.contains(style)) {
        document.head.removeChild(style)
      }
    }, 500)

    // Also check for any modal backdrops and remove them
    const modalBackdrops = document.querySelectorAll('[class*="backdrop"], [class*="overlay"], [class*="modal"]')
    modalBackdrops.forEach((el) => {
      if (el instanceof HTMLElement) {
        el.style.display = "none"
        if (el.parentNode) {
          try {
            el.parentNode.removeChild(el)
          } catch (e) {
            // Ignore errors if element can't be removed
          }
        }
      }
    })

    setIsPointerEventsNone(false)
  }

  if (!isVisible) return null

  return (
    <div
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        zIndex: 9999,
        pointerEvents: "auto", // Ensure this button is always clickable
      }}
    >
      <Button
        onClick={fixPointerEvents}
        variant={isPointerEventsNone ? "destructive" : "secondary"}
        style={{ pointerEvents: "auto" }} // Ensure this button is always clickable
      >
        {isPointerEventsNone ? "⚠️ Fix Pointer Events" : "Debug: Fix UI"}
      </Button>
    </div>
  )
}
